import ProtectiveCard from "./components/protective/protective-card.jsx";
import AttendanceCard from "./components/attendance/attendance-card.jsx";
import AggressorsCard from "./components/aggressors/aggressors-card.jsx";

export default function ProtectiveView({ protective }) {
    return (
        <>
            <ProtectiveCard data={protective} />
            <AttendanceCard data={protective} />
            <AggressorsCard data={protective} />
        </>
    )
}
